import React from "react";
import { useNavigate } from 'react-router-dom'
import { BoxArrowRight, ClockHistory } from 'react-bootstrap-icons';
import axiosService from "../../../utils/AxiosService";

const PmMenuDropdown = ({ isOpen, setIsOpen, currentProjectManager }) => {
  const navigate = useNavigate()
  const menuItem = "w-full px-4 py-3 flex items-center justify-between text-sm font-semibold text-rb-black dark:text-rb-dark-mode-text-light bg-white dark:bg-rb-dark-mode hover:bg-rb-grey dark:hover:bg-rb-dark-mode-lighter transition-colors"
  return (
    isOpen && (
      <div className="absolute top-11 right-7 z-50 w-64 rounded-lg border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode shadow-lg overflow-hidden">
        <ul>
          <li>
            <button
              className={menuItem}
              onClick={() => {
                navigate('/project_manager/edit_profile')
                setIsOpen(false);
              }}
            >
              Update Profile
            </button>
          </li>
          {currentProjectManager?.is_admin &&
            <li className="border-t-1 border-rb-widget-border dark:border-rb-dark-mode-lighter">
              <button
                className={menuItem}
                onClick={() => {
                  navigate('/project_manager/audit-log')
                  setIsOpen(false);
                }}
              >
                <span>Audit Log</span>
                <ClockHistory className="my-auto" />
              </button>
            </li>
          }
          <li className="border-t-1 border-rb-widget-border dark:border-rb-dark-mode-lighter">
            <button
              className={`${menuItem} text-rb-mat-grey dark:text-rb-dark-mode-text-grey`}
              onClick={() => axiosService.delete('/api/project_manager/logout').then(() => navigate('/project_manager/login')) }
            >
              <span className="mr-2">Logout</span>
              <BoxArrowRight className="my-auto" />
            </button>
          </li>
        </ul>
      </div>
    )
  );
}

export default PmMenuDropdown;
